import {
  BaSeButton,
  BaSeHeading6,
  BaSeParagraph,
  BaSeTheme,
} from '@base/react';
import React from 'react';
import { useMessage } from '../../../../../hooks/messages/useMessage';
import { useInterviewService } from '../../../../../hooks/services/interview-service';

const MESSAGE = {
  INTERVIEW: 'a(s) entrevista(s)',
  QUESTIONNAIRE: 'o(s) questionário(s)',
};

const messages = {
  1: MESSAGE.INTERVIEW,
  2: MESSAGE.QUESTIONNAIRE,
  3: MESSAGE.INTERVIEW,
  4: MESSAGE.INTERVIEW,
};
function ConfirmExclusionInterview({
  moduleId,
  name,
  closeModal,
  reloadData,
  cpfCandidate,
}) {
  const { deleteinterview } = useInterviewService();
  const { handleError, handleSuccess } = useMessage();
  const [loading, setLoading] = React.useState(false);

  const handleDeleteInterview = React.useCallback(() => {
    setLoading(true);
    deleteinterview(moduleId, cpfCandidate)
      .then(() => {
        closeModal();
        reloadData();
        handleSuccess(
          moduleId === 2
            ? 'Questionário(s) excluído(s) com sucesso.'
            : 'Entrevista(s) excluída(s) com sucesso.',
        );
      })
      .catch((error) => {
        handleError(error.message);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [
    closeModal,
    handleSuccess,
    deleteinterview,
    moduleId,
    handleError,
    cpfCandidate,
    reloadData,
  ]);

  return (
    <div style={{ display: 'grid', gap: 12 }}>
      <BaSeHeading6
        color={BaSeTheme.colors.feedbackInterface.atencao55}
        isBold={true}
      >
        Atenção!
      </BaSeHeading6>
      <BaSeParagraph>
        {`Tem certeza que deseja excluir ${messages[moduleId]} do candidato ${name}?`}
      </BaSeParagraph>

      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <BaSeButton
          color={BaSeTheme.colors.institucionais.azulSebrae10}
          value="Cancelar"
          onClick={() => closeModal()}
          isDisabled={loading}
        />

        <BaSeButton
          onClick={handleDeleteInterview}
          type="secondary"
          color={BaSeTheme.colors.institucionais.azulSebrae10}
          value="Excluir"
          isDisabled={loading}
        />
      </div>
    </div>
  );
}

export default ConfirmExclusionInterview;
